﻿import UnexpectedError from '@/pages/Errors/unexpectedError.tsx';
import { Component, ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError : false };

  static getDerivedStateFromError() {
    return { hasError : true };
  }

  componentDidUpdate(prevProps: ErrorBoundaryProps) {
    if (prevProps.children !== this.props.children) {
      this.setState({ hasError : false });
    }
  }

  render() {
    if (this.state.hasError) {
      return <UnexpectedError/>;
    }

    return this.props.children;
  }
}

export default function ErrorBoundaryWrapper({ children }: {children: ReactNode}) {
  const location = useLocation();

  return (
    <ErrorBoundary key={location.pathname}>
      {children}
    </ErrorBoundary>
  );
}
